import { CIVILITY_TYPES, COUNTRIES } from "@shared/constants";
import { getIsCountry } from "./getIsCountry";

export function getCivilityOptions(t) {
  const options = [
    {
      value: CIVILITY_TYPES.MR,
      label: t("myDetails.inputs.civilityLabels.MR"),
    },
    {
      value: CIVILITY_TYPES.MRS,
      label: t("myDetails.inputs.civilityLabels.MRS"),
    },
  ];

  if (
    !getIsCountry(COUNTRIES.ES) &&
    !getIsCountry(COUNTRIES.PT) &&
    !getIsCountry(COUNTRIES.FR)
  ) {
    options.push({
      value: CIVILITY_TYPES.MISS,
      label: t(`myDetails.inputs.civilityLabels.MISS`),
    });
  }

  return options;
}
